import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Observable, of, zip } from 'rxjs';
import { ITimeSeriesDataSerie } from '../../models/time-series-data-serie.interface';
import { ThemeType } from '@activia/ngx-components';
import { ServerOverviewService } from '../server-overview.service';
import { ICartesianSeries, SeriesTypes, themeTypeToCssVar } from '@activia/dataviz';
import { catchError, map } from 'rxjs/operators';
import { ThresholdThemePipe } from '../../pipes/threshold-theme.pipe';

@Component({
  selector: 'amp-server-overview-widget',
  templateUrl: './server-overview-widget.component.html',
  styleUrls: ['./server-overview-widget.component.scss'],
})
export class ServerOverviewWidgetComponent implements OnInit, OnChanges, OnDestroy {
  @Input() yAxisLabel: string;
  @Input() yAxisSoftMax: number;
  @Input() yAxisMax: number;
  @Input() yAxisTickInterval: number;

  /** datumSerieSource is from ServerOverviewService only */
  @Input() data: Array<{ label: string; datumSerieSource: Observable<ITimeSeriesDataSerie> }>;
  @Input() dataUnit: string;
  @Input() precision: number;
  @Input() thresholdThemes: Array<{ ceilingValue: number; color: ThemeType }>;
  @Input() valueFormatter: (val: number) => any;

  error: string;
  series: Array<ICartesianSeries> = [];
  data$: Observable<Array<ICartesianSeries> | string>;

  constructor(private serverOverviewService: ServerOverviewService) {
    this.serverOverviewService.start();
  }

  ngOnInit(): void {
    this.data$ = zip(...this.data.map((datum) => datum.datumSerieSource)).pipe(
      map((serieData) => {
        this.series = this.series.map((serie, idx) => {
          const value = this.valueFormatter ? this.valueFormatter(serieData[idx].y) : serieData[idx].y;
          return {
            ...serie,
            data: [
              ...serie.data,
              {
                x: serieData[idx].x,
                y: value,
              },
            ],
            color: this.thresholdThemes ? themeTypeToCssVar(new ThresholdThemePipe().transform(value, this.thresholdThemes)) : themeTypeToCssVar(ThemeType.PRIMARY),
          };
        });
        return this.series;
      }),
      catchError((error) => of(error))
    );
  }

  ngOnChanges({ data }: SimpleChanges): void {
    if (data?.currentValue) {
      this.series = this.data.map((datum) => ({
          key: datum.label,
          name: datum.label,
          type: SeriesTypes.AREA_LINE,
          color: themeTypeToCssVar(ThemeType.PRIMARY),
          lineWidth: 1,
          areaFillOpacity: 0.5,
          data: [],
          maxDataItems: ServerOverviewService.dataSetLimit,
        }));
    }
  }

  ngOnDestroy(): void {
    this.serverOverviewService.stop();
  }
}
